import { useEffect, type ReactNode } from 'react'

/* Building blocks for the platform admin screens (platform.css). */

export const P = {
  grid: 'M4 4h6v6h-6zM14 4h6v6h-6zM4 14h6v6h-6zM14 14h6v6h-6z',
  building: 'M3 21h18M5 21v-14l7-4l7 4v14M9 21v-6h6v6M9 10h.01M15 10h.01',
  db: 'M12 6m-8 0a8 3 0 1 0 16 0a8 3 0 1 0-16 0M4 6v6a8 3 0 0 0 16 0v-6M4 12v6a8 3 0 0 0 16 0v-6',
  list: 'M9 6h11M9 12h11M9 18h11M5 6v.01M5 12v.01M5 18v.01',
  key: 'M7 15m-4 0a4 4 0 1 0 8 0a4 4 0 1 0-8 0M10 12l9-9M15 6l3 3',
  search: 'M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0-14 0M21 21l-6-6',
  sun: 'M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0-8 0M3 12h1M20 12h1M12 3v1M12 20v1M5.6 5.6l.7 .7M18.4 5.6l-.7 .7M17.7 17.7l.7 .7M6.3 17.7l-.7 .7',
  moon: 'M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446a9 9 0 1 1 -8.313 -12.454z',
  palette: 'M12 21a9 9 0 0 1 0-18c4.97 0 9 3.582 9 8c0 1.06-.474 2.078-1.318 2.828c-.844.75-1.989 1.172-3.182 1.172h-2.5a2 2 0 0 0-1 3.75a1.3 1.3 0 0 1-1 2.25M7.5 10.5h.01M12 7.5h.01M16.5 10.5h.01',
  menu: 'M4 7h16M4 12h16M4 17h16',
  collapse: 'M4 5m0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-12a2 2 0 0 1-2-2zM9 5v14',
  plus: 'M12 5v14M5 12h14',
  x: 'M18 6l-12 12M6 6l12 12',
  chevron: 'M9 6l6 6l-6 6',
  logout: 'M14 8v-2a2 2 0 0 0-2-2h-7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-2M9 12h12l-3-3M18 15l3-3',
  users: 'M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0-8 0M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2M16 3.13a4 4 0 0 1 0 7.75M21 21v-2a4 4 0 0 0-3-3.85',
  heart: 'M19.5 12.572l-7.5 7.428l-7.5-7.428a5 5 0 1 1 7.5-6.566a5 5 0 1 1 7.5 6.572',
  activity: 'M3 12h4l3 8l4-16l3 8h4',
  pause: 'M6 5m0 1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1zM14 5m0 1a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1z',
  play: 'M7 4v16l13-8z',
  download: 'M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5l5-5M12 4v12',
  restore: 'M3 12a9 9 0 1 0 3-6.7L3 8M3 3v5h5',
  trash: 'M4 7h16M10 11v6M14 11v6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12M9 7v-3h6v3',
  edit: 'M4 20h4l10.5-10.5a2.828 2.828 0 1 0-4-4l-10.5 10.5v4M13.5 6.5l4 4',
  login: 'M15 8v-2a2 2 0 0 0-2-2h-7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-2M21 12h-13l3-3M11 15l-3-3',
  refresh: 'M20 11a8.1 8.1 0 0 0-15.5-2m-.5-4v4h4M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4',
  shield: 'M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1-8.5 15a12 12 0 0 1-8.5-15a12 12 0 0 0 8.5-3',
  arrowUp: 'M12 5v14M18 11l-6-6M6 11l6-6',
  arrowDown: 'M12 5v14M18 13l-6 6M6 13l6 6',
  home: 'M5 12l-2 0l9-9l9 9l-2 0M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7M9 21v-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6',
  desk: 'M8 7a4 4 0 1 0 8 0a4 4 0 0 0-8 0M6 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2',
  cal: 'M4 5m0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-12a2 2 0 0 1-2-2zM16 3l0 4M8 3l0 4M4 11l16 0',
  steth: 'M6 4h-1a2 2 0 0 0-2 2v3.5h0a5.5 5.5 0 0 0 11 0v-3.5a2 2 0 0 0-2-2h-1M8 15a6 6 0 1 0 12 0v-3M11 3v2M6 3v2M20 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0-4 0',
  tube: 'M20 8.04l-12.122 12.124a2.857 2.857 0 1 1-4.041-4.04l12.122-12.124M7 13h8M19 15l1.5 1.6a2 2 0 1 1-3 0l1.5-1.6zM15 3l6 6',
  file: 'M14 3v4a1 1 0 0 0 1 1h4M17 21h-10a2 2 0 0 1-2-2v-14a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2zM9 13l6 0M9 17l6 0',
  rupee: 'M18 5h-11h3a4 4 0 0 1 0 8h-3l6 6M7 9l11 0',
  chart: 'M3 3v18h18M7 15l4-4l3 3l5-6',
  settings: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 0 0-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 0 0-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 0 0-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 0 0-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 0 0 1.066-2.573c-.94-1.543.826-3.31 2.37-2.37c1 .608 2.296.07 2.572-1.065zM9 12a3 3 0 1 0 6 0a3 3 0 0 0-6 0',
  phone: 'M6 3m0 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2zM11 4h2M12 17v.01',
}

export function Icon({ d, size = 16 }: { d: string; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flex: 'none' }}><path d={d} /></svg>
  )
}

export function PageHeader({ crumbs, title, description, actions }: {
  crumbs: string[]; title: string; description?: ReactNode; actions?: ReactNode
}) {
  return (
    <div className="pa-head">
      <div>
        <div className="pa-crumbs">
          {crumbs.map((c, i) => (
            <span key={c} style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
              {i > 0 && <Icon d={P.chevron} size={11} />}{c}
            </span>
          ))}
        </div>
        <h1>{title}</h1>
        {description && <p>{description}</p>}
      </div>
      {actions && <div className="pa-head-actions">{actions}</div>}
    </div>
  )
}

export type Tone = 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'neutral'

export function Badge({ tone = 'neutral', dot, children }: { tone?: Tone; dot?: boolean; children: ReactNode }) {
  return <span className={`pa-badge t-${tone}`}>{dot && <span className="dot" />}{children}</span>
}

export function Kpi({ label, value, icon, tone = 'primary', delta, note }: {
  label: string; value: ReactNode; icon: string; tone?: Tone
  /** Percent change against the previous period; null when there is nothing to compare. */
  delta?: number | null; note?: string
}) {
  return (
    <div className="pa-card pa-kpi">
      <div className="pa-kpi-top">
        <span className="pa-kpi-label">{label}</span>
        <span className={`pa-kpi-ic t-${tone}`}><Icon d={icon} size={15} /></span>
      </div>
      <div className="pa-kpi-value">{value}</div>
      <div className="pa-kpi-delta">
        {delta != null && (
          <span className={delta >= 0 ? 'pa-delta-up' : 'pa-delta-down'}>
            {delta >= 0 ? '▲' : '▼'} {Math.abs(delta)}%
          </span>
        )}
        {note && <span>{note}</span>}
      </div>
    </div>
  )
}

export function Empty({ icon, title, children, action }: { icon: string; title: string; children?: ReactNode; action?: ReactNode }) {
  return (
    <div className="pa-empty">
      <span className="pa-empty-ic"><Icon d={icon} size={20} /></span>
      <b>{title}</b>
      {children && <p>{children}</p>}
      {action}
    </div>
  )
}

export function Alert({ kind, children, onClose }: { kind: 'ok' | 'error' | 'warn'; children: ReactNode; onClose?: () => void }) {
  return (
    <div className={`pa-alert ${kind}`} role={kind === 'error' ? 'alert' : 'status'}>
      <span>{children}</span>
      {onClose && <button type="button" className="x" aria-label="Dismiss" onClick={onClose}><Icon d={P.x} size={14} /></button>}
    </div>
  )
}

function useEscape(onClose: () => void) {
  useEffect(() => {
    const on = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', on)
    return () => window.removeEventListener('keydown', on)
  }, [onClose])
}

export function Modal({ title, description, children, footer, onClose }: {
  title: string; description?: ReactNode; children: ReactNode; footer: ReactNode; onClose: () => void
}) {
  useEscape(onClose)
  return (
    <div className="pa-backdrop" onMouseDown={onClose}>
      <div className="pa-modal" role="dialog" aria-modal="true" aria-label={title} onMouseDown={(e) => e.stopPropagation()}>
        <div className="pa-modal-head">
          <div><h2>{title}</h2>{description && <p>{description}</p>}</div>
          <button type="button" className="pa-btn pa-icon-btn" aria-label="Close" onClick={onClose}><Icon d={P.x} /></button>
        </div>
        <div className="pa-modal-body">{children}</div>
        <div className="pa-modal-foot">{footer}</div>
      </div>
    </div>
  )
}

export function Drawer({ title, subtitle, children, footer, onClose }: {
  title: ReactNode; subtitle?: ReactNode; children: ReactNode; footer?: ReactNode; onClose: () => void
}) {
  useEscape(onClose)
  return (
    <div className="pa-backdrop pa-drawer-back" onMouseDown={onClose}>
      <aside className="pa-drawer" role="dialog" aria-modal="true" onMouseDown={(e) => e.stopPropagation()}>
        <div className="pa-modal-head" style={{ paddingBottom: 16, borderBottom: '1px solid hsl(var(--border))' }}>
          <div><h2>{title}</h2>{subtitle && <p>{subtitle}</p>}</div>
          <button type="button" className="pa-btn pa-icon-btn" aria-label="Close" onClick={onClose}><Icon d={P.x} /></button>
        </div>
        <div className="pa-drawer-body">{children}</div>
        {footer && <div className="pa-modal-foot" style={{ borderRadius: 0 }}>{footer}</div>}
      </aside>
    </div>
  )
}

/** A stable soft colour for a name, for avatar tiles. */
export function toneFor(name: string): Tone {
  const tones: Tone[] = ['primary', 'success', 'info', 'warning']
  let h = 0
  for (const c of name) h = (h * 31 + c.charCodeAt(0)) >>> 0
  return tones[h % tones.length]!
}

export function initials(name: string): string {
  return name.split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p[0]!.toUpperCase()).join('')
}

export function ago(iso: string | null | undefined): string {
  if (!iso) return '—'
  const s = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 1000))
  if (s < 60) return 'just now'
  if (s < 3600) return `${Math.floor(s / 60)} min ago`
  if (s < 86400) return `${Math.floor(s / 3600)} h ago`
  if (s < 86400 * 30) return `${Math.floor(s / 86400)} d ago`
  return new Date(iso).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })
}

export function day(iso: string | null): string {
  if (!iso) return '—'
  return new Date(iso.length <= 10 ? `${iso}T00:00:00` : iso).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })
}

export const fmt = (n: number) => n.toLocaleString('en-IN')
